import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import momBaby from 'assets/images/banner_mom_baby_circle.png';

const SimCircleBanner = ({ src = momBaby, ...otherProps }) => {
	const theme = useTheme();
	return (
		<Box {...otherProps} paddingBottom={{ xs: 0 }} display={'flex'} alignContent={'flex-start'}>
			<Box
				component={'img'}
				border={0}
				borderRadius={80}
				boxShadow={20}
				borderColor={theme.palette.primary.main}
				loading='lazy'
				height={1}
				width={1}
				src={src}
				alt='...'
				maxWidth={{ md: '50vw' }}
				sx={{
					filter: theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none'
				}}
			/>
		</Box>
	);
};

export default SimCircleBanner;
